import { useSelector } from 'react-redux'
import { isPast } from 'date-fns'
import { useCallback, useMemo } from 'react'

import { isStoryPlacements } from '../../../../../../features/components/AdFacebookPreview/helpers'
import { isCarouselAdAllowed, isLineItemObjectiveVideoViews } from '../helpers/lineItemDetailsHelpers'

import { lineItemSelector } from '../../../../../../modules/selectors/lineItems'
import { facebookRightUploadAdLineItemSelector } from '../../../../../../modules/selectors/rights'

import { OBJECTIVE } from '../../../../../Multiplatform/CampaignForms/fields'

// there can be two cases of ad create form: 1) simple usage on line item summary page
// 2) usage inside multi-form on digital right summary page
// in the second case, we store newly created line item data inside separate redux store
export default function useLineItemDetails() {
  const rightUploadAdLineItemData = useSelector(facebookRightUploadAdLineItemSelector)
  const {
    id: lineItemId,
    time_stop: timeStop,
    placement_positions: placementPositions,
    [OBJECTIVE]: objective
  } = useSelector(lineItemSelector)

  // if has data from right upload ad data selector, use its line item data for
  const isRightUploadAd = !!rightUploadAdLineItemData.id

  const getRegularLineItemData = useCallback(() => {
    return {
      lineItemId,
      isAdSetEndDateInThePast: isPast(new Date(timeStop)),
      showAsStory: isStoryPlacements(placementPositions),
      placementPositions,
      isCarouselAdAllowed: isCarouselAdAllowed(objective),
      isVideoViews: isLineItemObjectiveVideoViews(objective)
    }
  }, [lineItemId, placementPositions, timeStop, objective])

  const getRightUploadAdLineItemData = useCallback(() => {
    const {
      id: rightUploadAdLineItemId,
      date_stop: rightUploadAdLineItemDateStop,
      placement_positions: rightUploadAdLineItemPlacementPositions,
      [OBJECTIVE]: rightUploadAdLineItemObjective
    } = rightUploadAdLineItemData

    return {
      lineItemId: rightUploadAdLineItemId,
      isAdSetEndDateInThePast: isPast(new Date(rightUploadAdLineItemDateStop)),
      showAsStory: isStoryPlacements(rightUploadAdLineItemPlacementPositions),
      placementPositions: rightUploadAdLineItemPlacementPositions,
      isCarouselAdAllowed: isCarouselAdAllowed(rightUploadAdLineItemObjective),
      isVideoViews: isLineItemObjectiveVideoViews(rightUploadAdLineItemObjective)
    }
  }, [rightUploadAdLineItemData])

  return useMemo(
    () => (isRightUploadAd ? getRightUploadAdLineItemData() : getRegularLineItemData()),
    [isRightUploadAd, getRightUploadAdLineItemData, getRegularLineItemData]
  )
}
